import React, { Component } from 'react';
import SVGIcon from './svg_icon';

interface Props {
  LeftIconComponent: React.ComponentType;
  RightIconComponent: React.ComponentType;
  onToggle: (toggleState: boolean) => void;
}

interface State {
  toggle: boolean;
}

class Switch extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      toggle: true,
    };
  }

  handleToggle = () => {
    this.setState((prevState) => {
      const newToggleState = !prevState.toggle;
      this.props.onToggle(newToggleState); // Invoke the callback with the new toggle state
      return {
        toggle: newToggleState,
      };
    });
  };

  render() {
    const { toggle } = this.state;
    const { LeftIconComponent, RightIconComponent } = this.props;
    const toggleClass = " transform translate-x-8";

    const leftIconColor = !toggle ? "text-blue-400 transition duration-300" : "text-blue-900 transition duration-300";
    const rightIconColor = !toggle ? "text-blue-900 transition duration-300" : "text-blue-400 transition duration-300";

    return (
      <div className="flex flex-col justify-center w-full items-end py-4 pr-4">
        <div
          className="relative outline outline-gray-200 outline-1 w-16 h-8 flex items-center stroke-white rounded-full py-1 cursor-pointer"
          onClick={this.handleToggle}
        >
          <SVGIcon IconComponent={LeftIconComponent} className={`absolute left-0 ml-1.5 z-10 ${leftIconColor}`} scale='scale-75' />
          <SVGIcon IconComponent={RightIconComponent} className={`absolute right-0 mr-1.5 z-10 ${rightIconColor}`} scale='scale-75' />
          <div
            className={
              "bg-gray-100 h-8 w-8 rounded-full transform duration-200 ease-in-out" +
              (toggle ? "" : toggleClass)
            }
          ></div>
        </div>
      </div>
    );
  }
}

export default Switch;
